import { render, staticRenderFns } from "./scoreRules.vue?vue&type=template&id=5536266d"
import script from "./scoreRules.vue?vue&type=script&lang=js"
export * from "./scoreRules.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./scoreRules.vue?vue&type=style&index=1&id=5536266d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports